import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";
import { election2023HomeMixin } from "./vue/mixins/elections2023";

initMain([election2023HomeMixin], {}, []);
header();
